import { GridBreakpointsMediaDown } from '@dbi-tools/ui-kit';
import { A } from '@dbi-tools/ui-kit/lib/link';
import styled from 'styled-components';

export const HeaderStyled = styled('div')`
  position: absolute;
  z-index: 10;
  top: 40px;
  width: 100%;
  background: #fffffff7;
  padding-top: 20px;
  padding-bottom: 20px;
  ${GridBreakpointsMediaDown.lg} {
    padding-top: 15px;
    padding-bottom: 15px;
  }
`;

export const LogoLink = styled(A)`
  display: block;
`;

export const LogoImg = styled('img')`
  display: block;
  margin: 0 auto;
  width: auto;
  height: 50px;
  ${GridBreakpointsMediaDown.lg} {
    width: auto;
    height: 34px;
  }
}
`;
